const extraServices = {
  header: {
    btnCreate: 'Crear',
  },

  toast: {
    error: {
      badResponse: '[Servicio adicional] respuesta incorrecta del servidor',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[Servicio adicional] creado correctamente',
      },
      edit: {},
      delete: {
        default: '[Servicio adicional] eliminado correctamente',
      },
    },
  },

  deleteModal: {
    header: 'Eliminar servicios adicionales',
    body: 'Está a punto de eliminar {{num}} servicios adicionales.',
  },

  table: {
    filters: {
      profileType: 'Tipo de perfil'
    },
    headers: {
      name: 'Servicio extra',
      profileType: 'Tipo de perfil',
      basePrice: 'Base',
      extraPrice: 'Cada extra',
      baseUpTo: 'Base hasta',
      surcharge: 'Recargo',
    },
    actions: {
      delete: 'Eliminar',
      export: 'Exportar',
    },
  },

  create: {
    successToast: {
      message: '¡Éxito! Servicio adicional creado',
    },
    errorToast: {
      message: 'Ocurrió un error. No se pudo crear el servicio adicional',
    },
  },

  edit: {
    successToast: {
      message: '¡Éxito! Servicio adicional actualizado',
    },
    errorToast: {
      message: 'Ocurrió un error. No se pudo actualizar el servicio adicional',
    },
  },

  forms: {
    header: {
      createExtraService: {
        title: 'Crear',
      },

      updateExtraService: {
        title: 'Actualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    information: {
      details: {
        header: 'Detalles',
        fields: {
          name: 'Servicio extra',
          profileType: 'Tipo de perfil',
          description: 'Descripción',
          profileTypeOptions: {
            retail: 'Minorista',
            individual: 'Individual',
            wholesale: 'Al por mayor',
            corporate: 'Corporativo',
            website: 'Sitio web',
            hotel: 'Hotel',
            thirdParty: 'Tercero',
            tourOperator: 'Operador de Turno',
            receiptiveOperator: 'Operador de recepción',
          },
        },
      },
      settings: {
        header: 'Configuraciones',
        fields: {
          basePrice: 'Base',
          extraPrice: 'Cada extra',
          baseUpTo: 'Base hasta',
          surcharge: 'Recargo',
        },
      },
    },
  },
};

export default extraServices;
